import React, { useMemo, useState } from "react";
import { GenericTable } from "@shared/components/GenericTable";
import { wxUtils } from "@features/wx/utils";
import { FileText, ExternalLink } from "lucide-react";

const badgeColors: Record<string, string> = {
  document: "bg-blue-100 text-blue-800",
  instruction: "bg-blue-100 text-blue-800",
  "video link": "bg-red-100 text-red-800",
  checklist: "bg-green-100 text-green-800",
  hotline: "bg-purple-100 text-purple-800",
};

const getBadgeClass = (key?: string) => badgeColors[key?.toLowerCase()] || "bg-gray-100 text-gray-800";

const renderDocumentLink = (doc: any) => {
  if (doc.file) {
    return (
      <a href={doc.file} target="_blank" rel="noopener noreferrer" className="flex items-center text-blue-600 hover:text-blue-800">
        <FileText className="h-4 w-4 mr-1" /> View File <ExternalLink className="h-3 w-3 ml-1" />
      </a>
    );
  }
  if (doc.link) {
    return (
      <a href={doc.link} target="_blank" rel="noopener noreferrer" className="flex items-center text-blue-600 hover:text-blue-800">
        <ExternalLink className="h-4 w-4 mr-1" /> Open Link <ExternalLink className="h-3 w-3 ml-1" />
      </a>
    );
  }
  return <span className="text-gray-500">No link/file</span>;
};

const createPaginationConfig = (data: any[], page: number, perPage: number) => ({
  currentPage: page,
  totalPages: Math.ceil((data?.length || 0) / perPage),
  totalItems: data?.length || 0,
  itemsPerPage: perPage,
  startItem: (page - 1) * perPage + 1,
  endItem: Math.min(page * perPage, data?.length || 0),
});

const getPaginatedData = (data: any[], page: number, perPage: number) => {
  if (!data || data.length === 0) return [];
  const startIndex = (page - 1) * perPage;
  return data.slice(startIndex, startIndex + perPage);
};

export const HelpResourcesTab = ({jobCard}: {jobCard: any}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const transformedData = useMemo(
    () => jobCard && wxUtils.transformJobCardDetail(jobCard),
    [jobCard]
  );
  const helpResourcesData = transformedData?.helpResourcesData || [];


const helpResourcesColumns = [
  {
    key: "resourceName",
    header: "Resource Name",
    render: (v: string) => (
      <span className="font-medium text-blue-600 hover:text-blue-800 cursor-pointer">
        {v}
      </span>
    ),
  },
  {
    key: "resourceType",
    header: "Resource Type",
    type: "badge" as const,
    badgeConfig: { getClassName: getBadgeClass },
  },
  {
    key: "details",
    header: "Details",
    render: (_: any, row: any) => renderDocumentLink(row),
  },
];
    return (
   
        <GenericTable
            data={getPaginatedData(helpResourcesData, currentPage, itemsPerPage)}
            columns={helpResourcesColumns}
            emptyMessage={`No help resources found`}
            rowKey={"resourceId"}
            pagination={createPaginationConfig(helpResourcesData, currentPage, itemsPerPage)}
            onPageChange={setCurrentPage}
        />
    )
}